var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/ic-search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-40.000000, -515.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 515.086306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0.00134930736,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50234931,9.00134931 C1.50234931,4.85934931 4.86034931,1.50134931 9.00234931,1.50134931 C13.1443493,1.50134931 16.5023493,4.85934931 16.5023493,9.00134931 C16.5023493,13.1443493 13.1443493,16.5013493 9.00234931,16.5013493 C4.86034931,16.5013493 1.50234931,13.1443493 1.50234931,9.00134931 Z M19.7823493,18.7223493 L15.8723493,14.8123493 C19.0823493,11.0173493 18.6073493,5.33834931 14.8123493,2.12834931 C11.0173493,-1.08165069 5.33834931,-0.606650693 2.12834931,3.18834931 C-1.08165069,6.98234931 -0.606650693,12.6613493 3.18834931,15.8713493 C6.54334931,18.7093493 11.4573493,18.7093493 14.8123493,15.8713493 L18.7223493,19.7813493 C19.0153493,20.0743493 19.4893493,20.0743493 19.7823493,19.7813493 C20.0743493,19.4883493 20.0743493,19.0153493 19.7823493,18.7223493 L19.7823493,18.7223493 Z",
    id: "Fill-316",
    fill: "#0073FF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.78a72968.svg";
export { ForwardRef as ReactComponent };